module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAUlJREFUWEfVlz0OwjAMRj/PqBILKxKHgiOwcB4WjgCHQmJlQULMRq4SFNqksdOGny6INsl7dhOnIbiLmWdE9PD/a/6GLBIQMzOAK4AdEZ0qw9cA9gAWJJfYADjLDQfe1JJgZoEfHUcCXvkMhA/k+eQSHfiL0Qq411BNIgUX7kuglsQQvCcwtUQOHhWYSkIDTwqMldDCBwVKJSzwrIBVwgpXCWglSuBqgZxEKdwkkJJwdcyXV3MVfStEmk0oEm3YzVzCzQKJTJgj99b/J/DVVxCb7R+bhENLrfoy1AA0bWKrLDsJLQNb2qpWQcmA1j7JDFgHCtNr6RsVsAyQqp7aMXoC2o6FZbtXqn/no3TKyLvZyX6W14R7meTBhJkbABcAc9fYvKVq5kNkF70BWIaHU7mxrXUu7GTiIAG3h9PgQUNEd200Y9pJ1j3rCcaiIEIiSn4LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/menu_close.png
// module id = ZNUK
// module chunks = 134